const Cell = ({
  revealed,
  flagged,
  isMine,
  neighborMines,
  x,
  y,
  revealCell,
  updateFlag,
}) => {
  const cellStyle = {
    width: 40,
    height: 40,
    backgroundColor:
      revealed && neighborMines === 0
        ? isMine
          ? "red"
          : "#00226f"
        : revealed && neighborMines !== 0
        ? "#00226f"
        : "grey",
    opacity: "0.8",
    border: "2px solid #FFD522",
    borderRadius: "6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "20px",
    cursor: "pointer",
    color: "cyan",
    fontWeight: "600",
  };

  const handleMousedown = (e, x, y) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.button === 0) {
      revealCell(x, y);
    }
    if (e.button === 2) {
      updateFlag(x, y);
    }
    return false;
  };

  window.addEventListener("contextmenu", function (e) {
    e.preventDefault();
  });

  return (
    <div style={cellStyle} onMouseDown={(e) => handleMousedown(e, x, y)}>
      {!revealed && flagged
        ? "🚩"
        : !revealed
        ? ""
        : neighborMines !== 0
        ? neighborMines
        : isMine
        ? "💣"
        : ""}
    </div>
  );
};

export default Cell;
